import { onUnmounted, Ref, watch } from "@vue/composition-api";
import { IS_BROWSER } from "@/lib/browserUtils";

export default function useBeforeUnloadTab(enable: Ref<boolean>) {
  if (!IS_BROWSER) {
    return;
  }
  const exitConfirmationMessage = (e: BeforeUnloadEvent) => {
    (e || window.event).preventDefault();
    (e || window.event).returnValue = true; //Gecko + IE
    return true; //Webkit, Safari, Chrome
  };

  watch(
    enable,
    enable => {
      if (enable) {
        window.addEventListener("beforeunload", exitConfirmationMessage);
      } else {
        window.removeEventListener("beforeunload", exitConfirmationMessage);
      }
    },
    { immediate: true }
  );

  onUnmounted(() => {
    window.removeEventListener("beforeunload", exitConfirmationMessage);
  });
}
